export default __webpack_public_path__ + "files/code_themes/f757dd511cf939d8c73910416da64ce6.css";